/**
* Created For: 高德地图路线导航插件
* Author: chenLiYan.
* Date: 2019/1/9 0009 15:14.
*/
<template>
  <transition name="page-move">
    <div class="map-driving-wrap flex-wrap flex-vertical" v-show="isShow">
      <v-title title="路线导航" :isShowBack="true" :isDefaultBack="false" @backHandle="hide(); back()"></v-title>
      <!--路线地图-->
      <el-amap
        class="a-map-box"
        ref="map"
        :vid="'aMapDriving'"
        :center="myPosition || [121.59996, 31.197646]"
        :zoom="12"
        :plugin="plugin">
      </el-amap>
      <!--路线文字说明-->
      <div id="driving_details">

      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'VMapDriving',
  components: {},
  props: {
    // 起始坐标
    myPosition: {
      type: [String, Array],
      default: ''
    },
    // 目标位置
    destination: {
      type: [String, Object],
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {}
    }
  },
  data () {
    return {
      isShow: false, // 是否显示
      isGetSuccess: false, // 是否获取路线成功，成功则显示路线详情
      driving: null, // 绘制路线地图实例
      // 地图插件
      plugin: [
        {
          pName: 'Scale',
          position: 'RB'
        }, // 标尺
        { pName: 'ToolBar' } // 缩放工具
      ]
    }
  },
  computed: {},
  beforeMount () {
    this.initAMapDriving()
  },
  methods: {
    show () {
      this.isShow = true
      // 绘制路线
      if (this.driving) {
        // 若已经成功加载了路线规划地图插件，则直接绘制路线
        this.drivingHandle()
      } else {
        // 重新初始路线规划地图插件
        this.initAMapDriving()
      }
    },
    hide () {
      this.isShow = false
      this.isGetSuccess = false
    },
    // 初始路线规划插件
    initAMapDriving () {
      this.$nextTick(() => {
        const vm = this
        if (vm.$refs.map && vm.$refs.map.$$getInstance()) {
          // eslint-disable-next-line no-undef
          AMap.plugin('AMap.Driving', function () {
            // eslint-disable-next-line no-undef
            vm.driving = new AMap.Driving({
              // 驾车路线规划策略，AMap.DrivingPolicy.LEAST_TIME是最快捷模式
              // eslint-disable-next-line no-undef
              policy: AMap.DrivingPolicy.LEAST_TIME,
              // map 指定将路线规划方案绘制到对应的AMap.Map对象上
              map: vm.$refs.map.$$getInstance(),
              // panel 指定将结构化的路线详情数据显示的对应的DOM上，传入值需是DOM的ID
              panel: 'driving_details'
            })
            // 已经显示时，触发路线搜索
            if (vm.isShow) {
              // 路线搜索
              vm.drivingHandle()
            }
          })
        }
      })
    },
    // 路线搜索
    drivingHandle () {
      const vm = this
      this.driving.search(this.myPosition || [116.427281, 39.903719], [this.destination.longitude, this.destination.latitude], function (status, result) {
        // result 即是对应的驾车导航信息，相关数据结构文档请参考  https://lbs.amap.com/api/javascript-api/reference/route-search#m_DrivingResult
        if (status === 'complete') {
          vm.isGetSuccess = true
          console.log('绘制驾车路线完成')
        } else {
          vm.isGetSuccess = false
          console.log('获取驾车数据失败：' + result)
        }
      })
    },
    back () {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="stylus" scoped>
    @import "../stylus/base/base.styl";
    // 高德地图路线导航弹窗
    .map-driving-wrap{
        position fixed
        width 100%
        height 100%
        padding 5px
        background rgba(0,0,0,.5)
        z-index 91
        background #fff
        transform: translate(0, 0)
    }
    .a-map-box{
        width 100%
        min-height 562px
    }
    #driving_details{
        border-top 4px solid $border-color
        overflow-y scroll
    }
    // 过渡效果
    .page-move-enter, .page-move-leave-active
        transform: translate(100%, 0)
    .page-move-enter-active, .page-move-leave-active
        transition: transform .3s
</style>
